import {
    IXetTotNghiepPhamViSinhVienActionTypes
} from "../../action-types/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetTotNghiepPhamViSinhVienReducer } from "../../reducer-model/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienReducer";

const iniState: IXetTotNghiepPhamViSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    xetTotNghiepPhamVis: [],
    xetTotNghiepPhamViChuaThems: [],
    importResults: [],
};

export const xetTotNghiepPhamViSinhVienReducer = (
    state: IXetTotNghiepPhamViSinhVienReducer = iniState,
    action: IXetTotNghiepPhamViSinhVienActionTypes
): IXetTotNghiepPhamViSinhVienReducer => {
    switch (action.type) {
        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xetTotNghiepPhamVis: action.payload,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_NOT_EXISTS_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_NOT_EXISTS_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xetTotNghiepPhamViChuaThems: action.payload,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_LOAD_NOT_EXISTS_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_ADD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_ADD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_ADD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_UPDATE_DUYET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_UPDATE_DUYET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_UPDATE_DUYET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_IMPORT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                importResults: [],
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_IMPORT_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                importResults: action.payload ?? [],
            };

        case "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN_IMPORT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        default:
            return state;
    }
};